<template>
  <div class="c-echarts-pip" v-loading="loading">
    <pie-echart v-if="ecData.length" :config-options="echartsOptions" />
    <no-data v-else />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import PieEchart from '@/components/echarts/echart-pie'

import { getPlanDataEvaluatePip } from '@/api/ptom.data.model'
export default {
  name: 'PipEvaluate',
  components: { PieEchart },
  props: {
    detailTime: {
      type: Array,
      required: true
    },
    platform: {
      type: Number
    },
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    }
  },
  data() {
    const tipTitle = '充值金额(元)'
    return {
      loading: null,
      ecData: [],
      echartsOptions: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '1%'
        },
        series: [
          {
            name: tipTitle,
            type: 'pie',
            center: ['45%', '42%'],
            radius: '40%',
            label: {
              formatter: '{b}：{d}%'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    getData() {
      const [begin, end] = this.detailTime || []
      this.ecData = []

      this.loading = true
      getPlanDataEvaluatePip({
        begTime: begin,
        enTime: end,
        platform: this.platform,
        gameId: this.productId,
        chlId: this.chlUserId,
        sourceId: this.sourceId
      }).then((data) => {
        if (typeof data !== 'symbol') {
          this.loading = false
          if (data && isArray(data.list)) {
            this.ecData = data.list.map((ret) => {
              ret.value = ret.y
              return ret
            })
            const dataSeries = this.echartsOptions.series.pop()
            this.$set(this.echartsOptions, 'series', [Object.assign(dataSeries, { data: this.ecData })])
          }
        }
      })
    }
  },
  created() {
    this.getData()
  },
  watch: {
    detailTime() {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-echarts-pip {
  width: 50%;
  height: 100%;
}
</style>
